<template>
  <div class="card-temporary-limit">
    <img src="./icon_home_linequan@2x.png" class="icon-quan">
    <div class="info">
      <div class="info-title">限时临额券</div>
      <div class="info-content">今日最高可提<span class="red">{{ limit }}</span>元</div>
    </div>
    <div class="animate-container">
      <img src="./icon_shouzhi@2x.png" class="icon1">
      <p>戳我提现</p>
      <img src="./arrow@2x.png" class="icon2">
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      visible: true
    }
  },
  props: {
    limit: {
      type: [String, Number],
      default: ''
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.card-temporary-limit {
  width: 670px;
  margin-left: -20px;
  margin-bottom: -40px;
  margin-top: 20px;
  background: #FFFFFF;
  box-shadow: inset 0px 20px 30px 0px #FFF5F3;
  border-radius: 0px 0px 20px 20px;
  display: flex;
  align-items: center;
  padding: 20px ;
  .icon-quan {
    width:80px;
    height:80px;
  }
  .animate-container {
    display: flex;
    align-items: center;
    gap:5px;
    @keyframes leftmove {
      to{
        transform: translateX(-15px);
      }
    }
    p {
      font-size: 24px;
      color:#666;
    }
    .icon1 {
      width:30px;
      height:30px;
      animation: leftmove .3s infinite alternate;  
    }
    .icon2 {
      width:10px;
      height:17px;
    }
  }
  .info {
    display: flex;
    flex-direction: column;
    margin-left: 20px;
    flex:1;
    .info-title {
      padding: 3px 0;
      text-align: center;
      background: #FFF1DF;
      border-radius: 4px;
      font-size: 24px;
      color: #763E12;
      width: 140px;
    }
    .info-content {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      font-weight: bold;
      color: #333333;
      text-align: left;
      padding-top: 10px;
      .red {
        color:#FF4633
      }
    }
  }
 
}
</style>